/** MUTATIONS */
import { gql } from '@apollo/client';

/** mutation to upsert flow config */
export const CREATE_OR_UPDATE_FLOW_CONFIG = gql`
    mutation createOrUpdateFlowConfig($input : CreateOrUpdateFlowConfigInput) {
        createOrUpdateFlowConfig(input : $input)
    }
`;

/** mutation to save and run reconciliation */
export const RUN_RECONCILIATION_FLOW_CONFIG = gql`
    mutation runReconciliation($input : RunReconInput) {
        runReconciliation(input : $input)
    }
`;

/** mutation to create user comment in recon result page */
export const CREATE_RECON_USER_COMMENTS = gql`
    mutation createReconUserComments($input : CreateReconUserCommentInput) {
        createReconUserComments(input : $input)
    }
`;
